import { platform } from '../lib/client';

export const audioCache = platform.audioCache;
